export default __webpack_public_path__ + "static/media/password-reset.1fd8a1a6.png";